import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Fade from "@mui/material/Fade";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const ModuleCard = (props) => {
  const classes = useStyles();
  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Card
          className={classes.card}
          sx={{ boxShadow: "4px 4px 10px 0px #E5E5E5", cursor: "pointer" }}
          onClick={() => {
            props.press();
          }}
        >
          <CardContent sx={{ py: 1, height: "9.5rem" }}>
            {props.title && (
              <Typography
                className={classes.ModuleNum}
                sx={{ color: "#FFFFFF", lineHeight: 1, pt: 1 }}
              >
                {props.title}
              </Typography>
            )}
            {props.subheading && (
              <Typography
                className={classes.ModuleName}
                sx={{ color: "#FFFFFF" }}
              >
                {/* {props.subheading} */ "Level"}
              </Typography>
            )}
            {props.caption && (
              <Typography
                className={classes.cardText}
                color="#FFFFFF"
                sx={{ borderTop: 1, borderColor: "#D9D9D9" }}
              >
                {/* {props.caption} */ " "}
              </Typography>
            )}
            {/* <Typography  className={classes.className}>
            6D
        </Typography> */}
          </CardContent>
          {/* <CardActions sx={{ justifyContent: "flex-end", py: 0, pb: 1 }}>
            {!props.greenTick && (
              <IconButton
                aria-label="Go"
                size="small"
                sx={{
                  borderRadius: "50%",
                  backgroundColor: "#F5F5F5",
                  color: "primary.main",
                  padding: 0.5,
                  "@media (min-width: 1636px)": {
                    mt: 6,
                  },
                 
                }}
              >
                <NavigateNextIcon
                  fontSize="inherit"
                  sx={{
                    fontSize: "1.5rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              </IconButton>
            )}
            {props.greenTick && (
              <IconButton
                aria-label="Done"
                size="small"
                sx={{
                  borderRadius: "50%",
                  backgroundColor: "#3ac241",
                  color: "#FFFFFF",
                  padding: 0.5,
                  "@media (min-width: 1636px)": {
                    mt: 6,
                  },
                 
                }}
              >
                <CheckCircleIcon
                  fontSize="inherit"
                  sx={{
                    fontSize: "1.5rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              </IconButton>
            )}
          </CardActions> */}
        </Card>
      </Box>
    </Fade>
  );
};

const useStyles = makeStyles({
  card: {
    background:
      "linear-gradient(to bottom, rgba(30,87,153,1) 0%,rgba(41,137,216,1) 50%,rgba(32,124,202,1) 51%,rgba(125,185,232,1) 100%)",
    width: "11rem",
    "@media (min-width: 1636px)": {
      width: "13rem",
      height: "17rem",
    },
  },
  ModuleNum: {
    fontSize: "3.2rem",
    textAlign: "center",
    fontWeight: "900",
    "@media (min-width: 1636px)": {
      fontSize: "3.2rem",
    },
  },
  ModuleName: {
    fontSize: "1rem",
    textAlign: "center",
    fontWeight: "600",
    paddingBottom: 10,
    "@media (min-width: 1636px)": {
      fontSize: "1.6rem",
      paddingBottom: 20,
    },
  },
  cardText: {
    fontSize: "0.9rem",
    textAlign: "center",
    paddingTop: 10,
    fontWeight: "500",
    "@media (min-width: 1636px)": {
      fontSize: "1.2rem",
      paddingTop: 20,
    },
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "0.8rem",
    marginTop: 5,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: "#F5F7FF",
    fontWeight: "500",
    "@media (min-width: 1636px)": {
      fontSize: "1.6rem",
    },
  },
});

export default ModuleCard;
